import { render } from "./App.vue?vue&type=template&id=3b48315d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3b48315d&lang=css"
script.render = render

export default script